export * from './documento-dinamico.directive';
